module.exports = __webpack_public_path__ + "img/done.ab55254d.png";